import { render, staticRenderFns } from "./UomApp.vue?vue&type=template&id=21560629&scoped=true"
import script from "./UomApp.vue?vue&type=script&lang=js"
export * from "./UomApp.vue?vue&type=script&lang=js"
import style0 from "./UomApp.vue?vue&type=style&index=0&id=21560629&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21560629",
  null
  
)

export default component.exports